import React, { ReactElement } from "react";
import styles from "./style.module.scss";
import StarRating from "@components/shared/starRating";

export default function OfferRating({
    rating,
    starRatingScore = 5,
    hideText = false,
    starRating = false,
    starsCount = 5,
}: {
    rating?: number;
    starRatingScore?: number;
    hideText?: boolean;
    starRating?: boolean;
    starsCount?: number;
}): ReactElement {
    const resolveWordedRating = (rating: number) => {
        if (rating >= 9.5) {
            return "Exceptional";
        }
        if (rating >= 8) {
            return "Excellent";
        }
        if (rating >= 7) {
            return "Great";
        }
        return "Good";
    };

    return (
        <>
            {rating ? (
                <div className={styles["rating"]}>
                    {!hideText && (
                        <span className={styles["worded"]}>
                            {resolveWordedRating(rating)}
                        </span>
                    )}

                    <span className={styles["numbered"]}>{rating}</span>

                    {starRating && (
                        <StarRating rating={starRatingScore} max={starsCount} />
                    )}
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
